import { z } from 'zod';
import { permissionNameSchema, permissionSchema, roleNameSchema, roleSchema, } from '../schemas/role.js';
import { listQueryBase, paginatedResponse } from './_shared.js';
/**
 * `GET /api/roles` — paginated role list. Gate `users:view`. Roles are
 * seed-driven (Appendix A); the list itself is small but the admin tab
 * paginates for consistency with the other tabs. `sort` is a signed
 * comma-joined field list validated server-side against the whitelist
 * (`name`, `description`).
 */
export const listRolesQuerySchema = listQueryBase.extend({
    search: z.string().min(1).max(200).optional(),
});
/**
 * `GET /api/roles/export` — same filters + sort as the list, without
 * pagination. Used to stream all matching rows as a `text/csv` attachment.
 */
export const exportRolesQuerySchema = listRolesQuerySchema.omit({
    page: true,
    pageSize: true,
});
export const listRolesResponseSchema = paginatedResponse(roleSchema);
/**
 * `GET /api/roles/permissions` — full permission catalogue. Gate
 * `users:view`. Used to populate the role-edit dialog's permission
 * checklist; the catalog is seeded and never mutated at runtime, so the
 * shape is a flat array (no pagination).
 */
export const listPermissionsResponseSchema = z.array(permissionSchema);
export const updateRoleParamsSchema = z.object({ name: roleNameSchema });
/**
 * `PATCH /api/roles/:name` body. Gate `users:update_roles`. Strict
 * whitelist: `permissions` items must match the seeded catalog (no
 * wildcards). The DB FK on `role_permissions.permission_name` enforces the
 * same rule at write time.
 */
export const updateRoleBodySchema = z
    .object({
    description: z.string().max(2000).nullable(),
    permissions: z.array(permissionNameSchema),
})
    .strict();
export const updateRoleResponseSchema = roleSchema;
//# sourceMappingURL=roles.js.map